(function(){
  'use strict';
  console.log('[BBCP] v2 script running');

  /* === Constants — mirror production custom-patch-designer.js === */
  const CDN_BASE = 'https://chronoslab.es/cdn/hats/SAPKA/';
  const CUSTOM_PATCH_VARIANT = 56702621319551;     /* SKU 10-000-00 — solo €16 */
  const CUSTOM_PATCH_COMBO = 56942137409919;       /* SKU 10-000-COMBO */
  const PATCH_PRICE = 16;
  const MAX_FILE_BYTES = 5 * 1024 * 1024;
  const PAN_STEP = 0.1;

  /* Patch template (single canonical asset, applies to all caps) */
  const PATCH_TEMPLATE_URL = 'https://cdn.shopify.com/s/files/1/0930/4453/9775/t/41/assets/custompatch.png?v=1767826739';
  const CROP = { x: 895, y: 820, w: 420, h: 410 };
  const FLAT_TEMPLATE = {
    url: 'https://cdn.shopify.com/s/files/1/0930/4453/9775/t/41/assets/patchempty-transparent.png?v=1767904026',
    crop: { x: 312, y: 318, w: 918, h: 906 },
    inner: { x: 47, y: 40, w: 824, h: 817, radius: 35 }
  };

  /* === Combo pricing (mirrors production getHatPrice) === */
  function getHatPrice(hatId){
    const model = hatId.split('-').slice(0, 2).join('-');
    return ({
      'A-7200': 73, 'A-3200': 73,
      'A-5500': 63,
      'A-3500': 53, 'A-3510': 53, 'A-7500': 53, 'A-4500': 53,
      'A-3100': 43, 'A-7100': 43, 'A-3400': 43, 'A-5400': 43, 'A-5410': 43, 'A-7410': 43
    })[model] || 53;
  }

  const MODEL_NAMES = {
    'A-3100':'Béisbol Clásico','A-3400':'Béisbol Niños','A-3500':'Béisbol Premium',
    'A-3510':'Béisbol Premium 6P','A-7100':'Trucker Clásico','A-7200':'Trucker Premium V2',
    'A-7410':'Trucker Niños','A-7500':'Trucker Premium'
  };
  const BENCH_EDIT_HATS = ["A-3100-252525","A-3400-151515","A-3400-333333","A-3500-030303","A-3500-090909","A-3500-101010","A-3500-141414","A-3500-191919","A-3500-202020","A-3500-291010","A-3500-292929","A-3500-293434","A-3500-303030","A-3510-020202","A-3510-151515","A-3510-171717","A-3510-290303","A-3510-291414","A-3510-291515","A-3510-293030","A-3510-303030","A-7100-010126","A-7100-010128","A-7100-040404","A-7100-171704","A-7100-171728","A-7100-242924","A-7100-292924","A-7100-292928","A-7200-292903","A-7410-333333","A-7500-030303","A-7500-030329","A-7500-032929","A-7500-050529","A-7500-101029","A-7500-102929","A-7500-141403","A-7500-141428","A-7500-142929","A-7500-171703","A-7500-191929","A-7500-290129","A-7500-290329","A-7500-291429","A-7500-292914"];
  const COLOR_CODES = {
    '02':{name:'Negro'},'03':{name:'Gris Oscuro'},'04':{name:'Gris'},'05':{name:'Gris Claro'},
    '10':{name:'Beige'},'14':{name:'Marrón'},'15':{name:'Camel'},'17':{name:'Camel Cl.'},
    '19':{name:'Arena'},'20':{name:'Naranja'},'24':{name:'Khaki'},'25':{name:'Azul Marino'},
    '26':{name:'Azul'},'28':{name:'Azul Cielo'},'29':{name:'Blanco'},'30':{name:'Rojo'},
    '33':{name:'Verde'},'34':{name:'Verde Osc.'},'35':{name:'Verde Cl.'}
  };

  /* === STATE === */
  const state = {
    currentStep: 1,
    fileMeta: { name: '', size: 0, w: 0, h: 0 },
    designCode: '', uploadedImage: null,        /* uploadedImage = original data URL */
    processedPatch: null, flatPatchForPrint: null,
    fillMode: 'FILL', zoom: 1, panX: 0, panY: 0, imageRotation: 0,
    hats: [], selectedHat: null, hatVariantId: null,
    activeType: 'all', hatSearch: '',
    copyrightOk: false, copyrightEmail: '', copyrightAcceptedAt: '',
    patchTemplateImg: null, /* preloaded */
  };

  const $ = id => document.getElementById(id);

  /* === STEPPER === */
  function enableStep(n){
    document.querySelectorAll('.bbcp-step').forEach(s => {
      const idx = parseInt(s.dataset.go);
      if (idx <= n) s.disabled = false;
    });
  }
  function goStep(n){
    state.currentStep = n;
    document.querySelectorAll('.bbcp-step').forEach(s => {
      const idx = parseInt(s.dataset.go);
      s.classList.toggle('active', idx === n);
      s.classList.toggle('done', idx < n);
    });
    document.querySelectorAll('.bbcp-pane').forEach(p => {
      p.classList.toggle('active', parseInt(p.dataset.pane) === n);
    });
    const top = document.querySelector('.bbcp-stepper');
    if (top) window.scrollTo({ top: top.offsetTop - 80, behavior: 'smooth' });
  }

  /* === DESIGN CODE === */
  function generateDesignCode(){
    const ts = Date.now().toString(36).toUpperCase();
    const r = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'BB-' + ts + '-' + r;
  }
  function fmtBytes(b){
    if (b < 1024) return b + ' B';
    if (b < 1024*1024) return (b/1024).toFixed(1) + ' KB';
    return (b/(1024*1024)).toFixed(2) + ' MB';
  }

  /* === COPYRIGHT CHECK (production endpoint) === */
  async function checkImageCopyright(imageDataUrl){
    try {
      const r = await fetch('https://chronoslab.es/api/custom-patch/check-image', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_data: imageDataUrl })
      });
      if (!r.ok){ console.log('[BBCP] copyright check server error', r.status); return true; }
      const result = await r.json();
      console.log('[BBCP] copyright check:', result);
      if (result.risk_level === 'blocked'){
        alert('⛔ Imagen rechazada\n\n' + (result.reason_es || 'Esta imagen contiene contenido protegido por derechos de autor o material inapropiado y no puede ser usada.'));
        return false;
      }
      if (result.risk_level === 'warning'){ console.warn('[BBCP] copyright warning:', result.reason_es); }
      return true;
    } catch(e){ console.error('[BBCP] copyright check error', e); return true; }
  }

  /* === FILE UPLOAD === */
  async function handleFile(file){
    if (!file) return;
    if (file.size > MAX_FILE_BYTES){ alert('La imagen supera 5MB. Comprime el archivo.'); return; }
    if (!/^image\/(jpeg|png|webp|svg\+xml)$/.test(file.type)){ alert('Formato no soportado. Sube JPG, PNG, WebP o SVG.'); return; }

    const upload = $('bbcp-upload');
    upload.style.opacity = '.5'; upload.style.pointerEvents = 'none';
    const reader = new FileReader();
    reader.onload = async function(){
      const dataUrl = reader.result;
      /* Copyright check */
      const ok = await checkImageCopyright(dataUrl);
      upload.style.opacity = ''; upload.style.pointerEvents = '';
      if (!ok) return;
      state.uploadedImage = dataUrl;
      state.designCode = generateDesignCode();
      state.fileMeta.name = file.name;
      state.fileMeta.size = file.size;
      const probe = new Image();
      probe.onload = function(){
        state.fileMeta.w = probe.naturalWidth;
        state.fileMeta.h = probe.naturalHeight;
        renderUploaded();
        processImageToPatch();
      };
      probe.src = dataUrl;
    };
    reader.readAsDataURL(file);
  }

  function renderUploaded(){
    $('bbcp-thumb').src = state.uploadedImage || '';
    $('bbcp-fname').textContent = state.fileMeta.name;
    $('bbcp-fsize').textContent = fmtBytes(state.fileMeta.size) + ' · ' + state.fileMeta.w + '×' + state.fileMeta.h + ' px';
    $('bbcp-fcode').textContent = 'Código: ' + state.designCode;
    $('bbcp-uploaded').classList.add('show');
    $('bbcp-controls').classList.add('show');
    $('bbcp-upload').style.display = 'none';
    $('bbcp-next1').disabled = false;
    enableStep(2); enableStep(3);
  }
  function clearUpload(){
    state.uploadedImage = null;
    state.processedPatch = null;
    state.flatPatchForPrint = null;
    state.fileMeta = { name: '', size: 0, w: 0, h: 0 };
    state.designCode = '';
    state.zoom = 1; state.panX = 0; state.panY = 0; state.fillMode = 'FILL';
    $('bbcp-zoom').value = 100;
    $('bbcp-zoom-val').textContent = '100%';
    $('bbcp-mode-fill').classList.add('active');
    $('bbcp-mode-fit').classList.remove('active');
    $('bbcp-uploaded').classList.remove('show');
    $('bbcp-controls').classList.remove('show');
    $('bbcp-upload').style.display = '';
    $('bbcp-file').value = '';
    $('bbcp-next1').disabled = true;
    document.querySelectorAll('.bbcp-step').forEach(s => {
      const idx = parseInt(s.dataset.go);
      if (idx > 1) s.disabled = true;
    });
    if (state.currentStep !== 1) goStep(1);
    updatePreview();
    updateBasket();
  }

  /* === PATCH TEMPLATE PRELOAD === */
  function preloadPatchTemplate(){
    if (state.patchTemplateImg) return Promise.resolve(state.patchTemplateImg);
    return fetch(PATCH_TEMPLATE_URL, { mode: 'cors' })
      .then(r => r.blob())
      .then(blob => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => { state.patchTemplateImg = img; resolve(img); };
        img.onerror = reject;
        img.src = URL.createObjectURL(blob);
      }));
  }

  /* === DRAW IMAGE FIT/FILL with zoom + pan + rotation (production logic) === */
  function drawImageFitOrFill(ctx, img, x, y, w, h, opts){
    opts = opts || {};
    const padding = opts.padding || 0;
    const mode = opts.mode || 'FIT';
    const zoom = opts.zoom || 1;
    const panX = opts.panX || 0, panY = opts.panY || 0;
    const rotation = opts.rotation || 0;
    const ix = x + padding, iy = y + padding;
    const iw = Math.max(1, w - padding*2), ih = Math.max(1, h - padding*2);
    const scaleFit = Math.min(iw/img.width, ih/img.height);
    const scaleFill = Math.max(iw/img.width, ih/img.height);
    let scale = (mode === 'FILL') ? scaleFill : scaleFit;
    scale *= zoom;
    const dw = img.width * scale, dh = img.height * scale;
    let dx = ix + (iw - dw)/2;
    let dy = iy + (ih - dh)/2;
    const panRangeX = Math.max(iw/4, (dw - iw)/2);
    const panRangeY = Math.max(ih/4, (dh - ih)/2);
    dx -= panX * panRangeX;
    dy -= panY * panRangeY;
    ctx.save();
    const cx = ix + iw/2, cy = iy + ih/2;
    ctx.translate(cx, cy);
    ctx.rotate(rotation * Math.PI/180);
    ctx.translate(-cx, -cy);
    ctx.drawImage(img, dx, dy, dw, dh);
    ctx.restore();
    return { dx, dy, dw, dh, scale };
  }

  /* === MASK + COMPOSITE (production: compositeImages + createMaskFromTemplate) === */
  function createMaskFromTemplate(patchImg){
    const c = document.createElement('canvas');
    c.width = CROP.w; c.height = CROP.h;
    const ctx = c.getContext('2d');
    ctx.drawImage(patchImg, CROP.x, CROP.y, CROP.w, CROP.h, 0, 0, CROP.w, CROP.h);
    const data = ctx.getImageData(0, 0, CROP.w, CROP.h);
    const px = data.data;
    for (let i = 0; i < px.length; i += 4){
      if ((px[i] + px[i+1] + px[i+2])/3 > 200 && px[i+3] > 200){
        px[i] = px[i+1] = px[i+2] = 255; px[i+3] = 255;
      } else { px[i+3] = 0; }
    }
    ctx.putImageData(data, 0, 0);
    return c;
  }
  function compositeImages(userImg, patchImg){
    const canvas = document.createElement('canvas');
    canvas.width = CROP.w; canvas.height = CROP.h;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const maskCanvas = createMaskFromTemplate(patchImg);
    /* Draw user image filling the patch crop */
    drawImageFitOrFill(ctx, userImg, 0, 0, CROP.w, CROP.h, {
      padding: 2, mode: state.fillMode, zoom: state.zoom,
      panX: state.panX, panY: state.panY, rotation: state.imageRotation
    });
    /* Mask user image to template's white inner */
    ctx.globalCompositeOperation = 'destination-in';
    ctx.drawImage(maskCanvas, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    /* Overlay frame (non-white parts of template) */
    const frameCanvas = document.createElement('canvas');
    frameCanvas.width = CROP.w; frameCanvas.height = CROP.h;
    const frameCtx = frameCanvas.getContext('2d');
    frameCtx.drawImage(patchImg, CROP.x, CROP.y, CROP.w, CROP.h, 0, 0, CROP.w, CROP.h);
    const frameData = frameCtx.getImageData(0, 0, CROP.w, CROP.h);
    const fp = frameData.data;
    for (let i = 0; i < fp.length; i += 4){
      if ((fp[i] + fp[i+1] + fp[i+2])/3 > 200) fp[i+3] = 0;
    }
    frameCtx.putImageData(frameData, 0, 0);
    ctx.drawImage(frameCanvas, 0, 0);
    state.processedPatch = canvas.toDataURL('image/png', 0.95);
    return canvas;
  }

  /* === FLAT TEMPLATE (production createFlatPatchPreview)
     Used for the standalone preview (step 1) — flat patch with BlackBork frame
     User image is clipped into rounded inner rect, then frame template overlaid */
  let _flatTemplateImg = null;
  function preloadFlatTemplate(){
    if (_flatTemplateImg) return Promise.resolve(_flatTemplateImg);
    return fetch(FLAT_TEMPLATE.url, { mode: 'cors' })
      .then(r => r.blob())
      .then(blob => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => { _flatTemplateImg = img; resolve(img); };
        img.onerror = reject;
        img.src = URL.createObjectURL(blob);
      }));
  }
  function drawRoundedRectPath(ctx, x, y, w, h, r){
    ctx.moveTo(x+r, y);
    ctx.lineTo(x+w-r, y);
    ctx.quadraticCurveTo(x+w, y, x+w, y+r);
    ctx.lineTo(x+w, y+h-r);
    ctx.quadraticCurveTo(x+w, y+h, x+w-r, y+h);
    ctx.lineTo(x+r, y+h);
    ctx.quadraticCurveTo(x, y+h, x, y+h-r);
    ctx.lineTo(x, y+r);
    ctx.quadraticCurveTo(x, y, x+r, y);
    ctx.closePath();
  }
  function buildFlatPatch(userImg, templateImg){
    const crop = FLAT_TEMPLATE.crop, inner = FLAT_TEMPLATE.inner;
    /* User image clipped into rounded inner area */
    const userCanvas = document.createElement('canvas');
    userCanvas.width = crop.w; userCanvas.height = crop.h;
    const userCtx = userCanvas.getContext('2d');
    userCtx.beginPath();
    drawRoundedRectPath(userCtx, inner.x, inner.y, inner.w, inner.h, inner.radius);
    userCtx.clip();
    drawImageFitOrFill(userCtx, userImg, inner.x, inner.y, inner.w, inner.h, {
      padding: 2, mode: state.fillMode, zoom: state.zoom,
      panX: state.panX, panY: state.panY, rotation: 0
    });
    /* Template (frame) with the inner rounded rect cut out so user image shows through */
    const templateCanvas = document.createElement('canvas');
    templateCanvas.width = crop.w; templateCanvas.height = crop.h;
    const tplCtx = templateCanvas.getContext('2d');
    tplCtx.drawImage(templateImg, crop.x, crop.y, crop.w, crop.h, 0, 0, crop.w, crop.h);
    tplCtx.save();
    tplCtx.globalCompositeOperation = 'destination-out';
    tplCtx.beginPath();
    drawRoundedRectPath(tplCtx, inner.x, inner.y, inner.w, inner.h, inner.radius);
    tplCtx.fill();
    tplCtx.restore();
    /* Composite: user image first, then frame on top */
    const finalCanvas = document.createElement('canvas');
    finalCanvas.width = crop.w; finalCanvas.height = crop.h;
    const finalCtx = finalCanvas.getContext('2d');
    finalCtx.drawImage(userCanvas, 0, 0);
    finalCtx.drawImage(templateCanvas, 0, 0);
    state.flatPatchForPrint = finalCanvas.toDataURL('image/png', 0.95);
    return state.flatPatchForPrint;
  }

  async function processImageToPatch(){
    if (!state.uploadedImage) return;
    try {
      const userImg = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = state.uploadedImage;
      });
      /* Build BOTH:
         - state.processedPatch: curved/cap-fitted version (compositeImages with custompatch.png)
         - state.flatPatchForPrint: flat framed version (createFlatPatchPreview style) */
      try {
        const flatTpl = await preloadFlatTemplate();
        buildFlatPatch(userImg, flatTpl);
      } catch(e){ console.warn('[BBCP] flat template failed:', e); }
      try {
        const tpl = await preloadPatchTemplate();
        compositeImages(userImg, tpl);
      } catch(e){ console.warn('[BBCP] curved template failed:', e); }
      updatePreview();
      updateBasket();
    } catch(e){
      console.error('[BBCP] processImageToPatch failed:', e);
    }
  }

  /* === PREVIEW ===
     - Step 1 (no hat): show user's raw image as a flat clean square
     - Step 2 (hat selected): show user image fitted onto the cap's patch area (no white bg, ~20% width)
     The canvas-composited PNG (state.processedPatch) is only used for the print order, not visual preview. */
  function updatePreview(){
    const empty = $('bbcp-stagent'), cap = $('bbcp-cap'), ov = $('bbcp-overlay'), patch = $('bbcp-patch');
    const stage = $('bbcp-stage');
    if (!state.uploadedImage){
      empty.style.display = ''; cap.style.display = 'none'; ov.style.display = 'none';
      stage.classList.remove('has-hat');
      return;
    }
    empty.style.display = 'none';

    if (state.selectedHat){
      /* Step 2 — on cap: use curved/composited version (with frame, fitted to cap perspective) */
      cap.src = state.selectedHat.image;
      cap.style.display = '';
      stage.classList.add('has-hat');
      patch.src = state.processedPatch || state.flatPatchForPrint || state.uploadedImage;
      patch.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;background:transparent;';
      positionPatchOnCap();
    } else {
      /* Step 1 — standalone: use FLAT framed patch (BlackBork bordered, square) */
      cap.style.display = 'none';
      stage.classList.remove('has-hat');
      patch.src = state.flatPatchForPrint || state.uploadedImage;
      patch.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;background:transparent;';
      const w = stage.clientWidth, h = stage.clientHeight;
      const sz = Math.min(w, h) * 0.62;
      const left = (w - sz) / 2, top = (h - sz) / 2;
      ov.style.cssText = 'display:block;position:absolute;left:'+left+'px;top:'+top+'px;width:'+sz+'px;height:'+sz+'px;pointer-events:none;z-index:10;background:transparent;';
    }
  }
  function positionPatchOnCap(){
    const cap = $('bbcp-cap'), ov = $('bbcp-overlay'), stage = $('bbcp-stage');
    if (!cap || !ov || !stage) return;
    const apply = function(){
      const stageW = stage.clientWidth, stageH = stage.clientHeight;
      if (stageW === 0 || stageH === 0){ setTimeout(apply, 100); return; }
      /* The cap <img> has CSS padding:5% with box-sizing:border-box,
         so the rendered cap pixels occupy stage minus 5% on each side. */
      const padPct = 0.05;
      const padX = stageW * padPct, padY = stageH * padPct;
      const capW = stageW - padX * 2, capH = stageH - padY * 2;

      /* Per-model patch panel position (% of CAP CONTENT area).
         Sized to MATCH the cap's actual woven patch panel (~19% of cap visible width). */
      const model = (state.selectedHat && state.selectedHat.model) || '';
      let params = { widthPct: 0.18, cxPct: 0.525, cyPct: 0.515 };
      if (model === 'A-7500' || model === 'A-7200' || model === 'A-7100' || model === 'A-7410'){
        /* Trucker: panel slightly upper-front of crown */
        params = { widthPct: 0.19, cxPct: 0.528, cyPct: 0.518 };
      } else if (model === 'A-3100' || model === 'A-3400' || model === 'A-3500' || model === 'A-3510'){
        /* Béisbol: panel a bit higher (cap profile is rounder) */
        params = { widthPct: 0.175, cxPct: 0.535, cyPct: 0.485 };
      }
      const patchW = capW * params.widthPct, patchH = patchW;
      const cx = padX + capW * params.cxPct;
      const cy = padY + capH * params.cyPct;
      const left = cx - patchW/2, top = cy - patchH/2;
      ov.style.cssText = 'display:block;position:absolute;left:'+left+'px;top:'+top+'px;width:'+patchW+'px;height:'+patchH+'px;transform:none;pointer-events:none;z-index:10;border-radius:4px;overflow:hidden;';
    };
    /* Use onload (not addEventListener once) so it refires on every src change.
       Also call apply() now in case the cap image is already in browser cache. */
    cap.onload = apply;
    if (cap.complete && cap.naturalWidth > 0) apply();
  }

  /* === HAT GRID === */
  function parseColors(sku){
    const last = sku.split('-').pop();
    const codes = [];
    if (!last) return codes;
    for (let i = 0; i < last.length; i += 2){
      const c = last.substr(i, 2);
      if (COLOR_CODES[c] && !codes.includes(c)) codes.push(c);
    }
    return codes;
  }
  async function loadHats(){
    let allProducts = [];
    for (let page = 1; page <= 10; page++){
      try {
        const r = await fetch('/products.json?limit=250&page=' + page);
        const d = await r.json();
        if (!d.products || d.products.length === 0) break;
        allProducts = allProducts.concat(d.products);
        if (d.products.length < 250) break;
      } catch(e){ break; }
    }
    const setHats = new Set(BENCH_EDIT_HATS);
    const productPrices = {};
    allProducts.forEach(p => {
      (p.variants || []).forEach(v => {
        const sku = v.sku || '';
        if (sku.startsWith('A-') && sku.length > 20){
          const m = sku.substring(0, 6);
          if (!productPrices[m]) productPrices[m] = parseFloat(v.price);
        }
      });
    });
    const hats = [];
    allProducts.forEach(p => {
      const imgs = p.images || [];
      (p.variants || []).forEach(v => {
        const sku = v.sku || '';
        if (setHats.has(sku)){
          const img = imgs.find(i => i.variant_ids && i.variant_ids.includes(v.id));
          if (img){
            const model = sku.split('-').slice(0, 2).join('-');
            const price = parseFloat(v.price) || productPrices[model] || 49;
            hats.push({
              id: p.id, variantId: v.id, title: p.title, sku, model,
              price, image: img.src, colors: parseColors(sku),
            });
          }
        }
      });
    });
    state.hats = hats;
    renderHatGrid();
  }
  function filteredHats(){
    let list = state.hats.slice();
    if (state.activeType !== 'all'){
      if (state.activeType === 'kids') list = list.filter(h => h.model === 'A-3400' || h.model === 'A-7410');
      else list = list.filter(h => h.model === state.activeType);
    }
    if (state.hatSearch){
      const q = state.hatSearch.toLowerCase();
      list = list.filter(h => h.title.toLowerCase().includes(q) || h.sku.toLowerCase().includes(q) ||
        h.colors.some(c => (COLOR_CODES[c]?.name || '').toLowerCase().includes(q)) ||
        (MODEL_NAMES[h.model] || '').toLowerCase().includes(q));
    }
    return list;
  }
  function renderHatGrid(){
    const list = filteredHats();
    const grid = $('bbcp-hatgrid');
    if (!grid) return;
    if (list.length === 0){
      grid.innerHTML = '<div class="bbcp-empty">No hay gorras con estos filtros.</div>';
      return;
    }
    grid.innerHTML = list.map(h => {
      const combo = getHatPrice(h.sku);
      return `
        <div class="bbcp-prod ${state.selectedHat && state.selectedHat.sku === h.sku ? 'selected' : ''}" data-sku="${h.sku}" title="${h.title}">
          <img loading="lazy" src="${h.image}" alt="${h.title}" onerror="this.src='${CDN_BASE}${h.sku}.png'">
          <span class="price">€${combo}</span>
        </div>`;
    }).join('');
    grid.querySelectorAll('.bbcp-prod').forEach(el => el.addEventListener('click', () => {
      const sku = el.dataset.sku;
      const hat = state.hats.find(h => h.sku === sku);
      if (!hat) return;
      const same = state.selectedHat && state.selectedHat.sku === hat.sku;
      state.selectedHat = same ? null : Object.assign({}, hat, { hatId: hat.sku });
      state.hatVariantId = same ? null : hat.variantId;
      grid.querySelectorAll('.bbcp-prod').forEach(x => x.classList.remove('selected'));
      if (!same) el.classList.add('selected');
      updatePreview();
      updateBasket();
    }));
  }

  /* === CART SUMMARY (production pricing) ===
     - Solo patch:    €16
     - Patch + cap:   €getHatPrice (43-73 inclusive of patch — patch shown GRATIS)
  */
  function updateBasket(){
    if (state.uploadedImage){
      $('bbcp-r-patch').textContent = 'Diseño personalizado · ' + state.designCode;
    } else {
      $('bbcp-r-patch').textContent = 'Pendiente';
    }
    if (state.selectedHat){
      $('bbcp-r-hat').textContent = (MODEL_NAMES[state.selectedHat.model] || state.selectedHat.model) + ' · ' + state.selectedHat.sku;
      $('bbcp-r-hat-p').textContent = '€' + getHatPrice(state.selectedHat.sku);
      $('bbcp-r-patch-p').textContent = 'GRATIS';
    } else {
      $('bbcp-r-hat').textContent = 'No seleccionada';
      $('bbcp-r-hat-p').textContent = '—';
      $('bbcp-r-patch-p').textContent = '€' + PATCH_PRICE;
    }
    const total = state.selectedHat
      ? getHatPrice(state.selectedHat.sku)
      : (state.uploadedImage ? PATCH_PRICE : 0);
    $('bbcp-total').textContent = '€' + total;
    $('bbcp-addbtn').disabled = !(state.uploadedImage && state.copyrightOk);
  }

  /* === EMAIL MODAL (production showEmailModal) === */
  function showEmailModal(){
    return new Promise((resolve, reject) => {
      const modal = $('bbcp-email-modal');
      const input = $('bbcp-email-modal-input');
      const err = $('bbcp-email-modal-err');
      const ok = $('bbcp-email-modal-confirm');
      const cancel = $('bbcp-email-modal-cancel');
      modal.style.display = 'flex';
      input.value = ''; err.style.display = 'none';
      input.focus();
      function clean(){
        modal.style.display = 'none';
        ok.removeEventListener('click', onOk);
        cancel.removeEventListener('click', onCancel);
        input.removeEventListener('keydown', onKey);
      }
      function onOk(){
        const v = input.value.trim();
        if (!v || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){
          err.style.display = 'block'; return;
        }
        clean(); resolve(v);
      }
      function onCancel(){ clean(); reject(new Error('cancelled')); }
      function onKey(e){
        if (e.key === 'Enter') onOk();
        else if (e.key === 'Escape') onCancel();
        else err.style.display = 'none';
      }
      ok.addEventListener('click', onOk);
      cancel.addEventListener('click', onCancel);
      input.addEventListener('keydown', onKey);
    });
  }

  /* === UPLOAD PATCH IMAGE TO CHRONOSLAB (production) === */
  async function uploadPatchImage(){
    if (!state.designCode) throw new Error('No design code');
    const imageToUpload = state.processedPatch;
    if (!imageToUpload) throw new Error('No image to upload');
    const body = {
      design_code: state.designCode,
      image_data: imageToUpload,
      original_data: state.uploadedImage,
      hat_id: state.selectedHat ? state.selectedHat.sku : 'unknown',
      timestamp: new Date().toISOString(),
      settings: { fillMode: state.fillMode, zoom: state.zoom, panX: state.panX, panY: state.panY },
      customer: window.CUSTOMER_INFO ? {
        name: window.CUSTOMER_INFO.name, email: window.CUSTOMER_INFO.email, id: window.CUSTOMER_INFO.id
      } : null,
      copyright_email: state.copyrightEmail || '',
      copyright_accepted_at: state.copyrightAcceptedAt || '',
      copyright_agreed: true,
      copyright_agreed_at: new Date().toISOString(),
      copyright_text: 'El diseno/fotografia que he subido es de mi propiedad y no contiene ningun contenido protegido por derechos de autor. Asumo toda la responsabilidad legal sobre el uso de este diseno.'
    };
    const r = await fetch('https://chronoslab.es/api/custom-patch/upload', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (r.ok){
      const result = await r.json();
      console.log('[BBCP] uploaded:', result);
      return;
    }
    if (r.status === 413){
      /* Retry without original */
      delete body.original_data;
      const r2 = await fetch('https://chronoslab.es/api/custom-patch/upload', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
      });
      if (!r2.ok) throw new Error('No se pudo guardar el diseño. Inténtalo de nuevo.');
      console.log('[BBCP] uploaded (no original):', await r2.json());
      return;
    }
    throw new Error('No se pudo guardar el diseño (error ' + r.status + ').');
  }

  /* === ADD TO CART (production logic) === */
  async function addToCart(){
    if (!state.uploadedImage){ alert('Sube un diseño primero.'); return; }
    if (!state.copyrightOk){ alert('Confirma los derechos de autor.'); return; }
    if (!state.processedPatch){
      /* Process now if missing */
      await processImageToPatch();
    }
    const btn = $('bbcp-addbtn');
    /* Email modal if not logged in */
    if (!window.CUSTOMER_INFO && !state.copyrightEmail){
      try {
        const email = await showEmailModal();
        state.copyrightEmail = email;
        state.copyrightAcceptedAt = new Date().toISOString();
      } catch(e){ return; /* cancelled */ }
    }
    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span style="display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:bbcp-spin .8s linear infinite"></span> Subiendo diseño…';
    try {
      await uploadPatchImage();
      const items = [];
      const addHat = !!state.selectedHat;
      const bundleId = addHat ? ('CP' + Date.now().toString(36)) : null;
      /* ALWAYS push the patch variant (production behaviour) */
      const patchProps = {
        _diseño: state.designCode,
        _gorra: state.selectedHat ? state.selectedHat.sku : '-',
        _fecha: new Date().toLocaleDateString('es-ES'),
        _custom_patch: 'true',
        _design_image_url: 'https://chronoslab.es/cdn/custom-patches/' + state.designCode + '.png',
      };
      if (bundleId){
        patchProps._bundle_id = bundleId;
        patchProps._combo_type = 'custom_patch_con_gorra';
      }
      items.push({ id: CUSTOM_PATCH_VARIANT, quantity: 1, properties: patchProps });
      if (addHat){
        items.push({
          id: state.hatVariantId, quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _combo_type: 'gorra_con_custom_patch',
            _custom_patch_design: state.designCode,
          }
        });
      }
      const r = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!r.ok){
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || 'Error añadiendo al carrito');
      }
      /* FB pixel */
      try {
        const totalValue = addHat ? getHatPrice(state.selectedHat.sku) : PATCH_PRICE;
        const contentIds = ['10-000-00'];
        if (addHat) contentIds.push(state.selectedHat.sku);
        if (typeof fbq !== 'undefined'){
          fbq('track', 'AddToCart', {
            content_type: 'product',
            content_name: 'Parche personalizado por Gorra de BlackBörk',
            content_ids: contentIds, currency: 'EUR', value: totalValue
          });
        }
      } catch(_){ }
      btn.innerHTML = '✓ Añadido · Redirigiendo…';
      btn.style.background = 'var(--bb-success)';
      setTimeout(() => window.location.href = '/cart', 800);
    } catch(e){
      console.error('[BBCP] cart fail:', e);
      alert(e.message || 'Error al añadir al carrito.');
      btn.innerHTML = original;
      btn.disabled = false;
    }
  }

  /* === EVENTS === */
  document.querySelectorAll('.bbcp-step').forEach(s => s.addEventListener('click', () => {
    if (s.disabled) return;
    goStep(parseInt(s.dataset.go));
  }));
  $('bbcp-next1').addEventListener('click', () => goStep(2));
  $('bbcp-back2').addEventListener('click', () => goStep(1));
  $('bbcp-next2').addEventListener('click', () => goStep(3));
  $('bbcp-back3').addEventListener('click', () => goStep(2));
  $('bbcp-skiphat').addEventListener('click', () => goStep(3));

  const dropZone = $('bbcp-upload');
  const fileInput = $('bbcp-file');
  dropZone.addEventListener('click', () => fileInput.click());
  fileInput.addEventListener('change', e => handleFile(e.target.files[0]));
  dropZone.addEventListener('dragover', e => { e.preventDefault(); dropZone.classList.add('drag'); });
  dropZone.addEventListener('dragleave', () => dropZone.classList.remove('drag'));
  dropZone.addEventListener('drop', e => {
    e.preventDefault(); dropZone.classList.remove('drag');
    handleFile(e.dataTransfer.files[0]);
  });
  $('bbcp-replace').addEventListener('click', () => fileInput.click());
  $('bbcp-remove').addEventListener('click', clearUpload);

  $('bbcp-mode-fit').addEventListener('click', () => {
    state.fillMode = 'FIT';
    $('bbcp-mode-fit').classList.add('active');
    $('bbcp-mode-fill').classList.remove('active');
    processImageToPatch();
  });
  $('bbcp-mode-fill').addEventListener('click', () => {
    state.fillMode = 'FILL';
    $('bbcp-mode-fill').classList.add('active');
    $('bbcp-mode-fit').classList.remove('active');
    processImageToPatch();
  });
  $('bbcp-zoom').addEventListener('input', e => {
    state.zoom = parseInt(e.target.value) / 100;
    $('bbcp-zoom-val').textContent = e.target.value + '%';
    processImageToPatch();
  });
  /* Pan controls */
  document.querySelectorAll('.bbcp-pan-btn').forEach(b => b.addEventListener('click', () => {
    const dir = b.dataset.pan;
    if (dir === 'up')    state.panY = Math.max(-1, state.panY - PAN_STEP);
    if (dir === 'down')  state.panY = Math.min( 1, state.panY + PAN_STEP);
    if (dir === 'left')  state.panX = Math.max(-1, state.panX - PAN_STEP);
    if (dir === 'right') state.panX = Math.min( 1, state.panX + PAN_STEP);
    if (dir === 'reset'){ state.panX = 0; state.panY = 0; }
    processImageToPatch();
  }));

  document.querySelectorAll('#bbcp-typechips .bbcp-chip').forEach(c => c.addEventListener('click', () => {
    document.querySelectorAll('#bbcp-typechips .bbcp-chip').forEach(x => x.classList.remove('active'));
    c.classList.add('active');
    state.activeType = c.dataset.type;
    renderHatGrid();
  }));
  $('bbcp-hatsearch').addEventListener('input', e => { state.hatSearch = e.target.value; renderHatGrid(); });

  $('bbcp-copyright').addEventListener('change', e => {
    state.copyrightOk = e.target.checked;
    updateBasket();
  });
  $('bbcp-addbtn').addEventListener('click', addToCart);

  /* Boot */
  console.log('[BBCP] booting');
  preloadPatchTemplate().catch(e => console.warn('[BBCP] template preload fail:', e));
  loadHats().then(() => console.log('[BBCP] hats:', state.hats.length))
            .catch(e => console.error('[BBCP] hats fail:', e));
  updateBasket();
})();
